/** Static Coil furnishings. Map-owned platforms retain collision and support;
 * wisps and incisions are painted details, not lights, particles or animation. */
export const COIL_PROP_TEMPLATES = {
  eldritch_altar: { kind: 'dais', name: 'Stepped Coil altar', frame: { w: 160, h: 64 }, band: 'architecture' },
  cracked_colonnade: { kind: 'colonnade_column', name: 'Fractured obsidian column', frame: { w: 56, h: 176 }, band: 'architecture' },
  void_brazier: { kind: 'lantern_post', name: 'Carved wisp brazier', frame: { w: 64, h: 104 }, band: 'architecture' },
  runic_slab: { kind: 'broken_pillar', name: 'Toppled Coil inscription', frame: { w: 104, h: 32 }, band: 'vegetation' },
} as const;

export type CoilPropTemplate = keyof typeof COIL_PROP_TEMPLATES;

/** Explicit channels for copying into authored props; no runtime theme lookup.
 * Muted lichen follows the October 17 subterranean palette, with small pale
 * marks against readable charcoal facets rather than broad saturated glow. */
export const COIL_PROP_PALETTES = {
  undercroft: {
    primary: '#293332', shade: '#101a1c', roof: '#172225', roofEdge: '#62716b',
    wood: '#26312b', woodEdge: '#6b7868', stone: '#42514d', iron: '#0c1518',
    glass: '#6b8a62', glassCore: '#9aa98b',
  },
  weathered: {
    primary: '#465457', shade: '#222e33', roof: '#303d43', roofEdge: '#899792',
    wood: '#394743', woodEdge: '#849080', stone: '#63716c', iron: '#19262b',
    glass: '#809880', glassCore: '#b0bba1',
  },
} as const;
